<template>
  <l-layer-group ref="lgroup" :name="name" :visible="visible" layer-type="base">
    <slot></slot>
  </l-layer-group>
</template>

<script>
import { LLayerGroup } from 'vue2-leaflet'

export default {
  name: 'MapLayergroup',
  props: ['name', 'visible'],
  components: {
    LLayerGroup
  },
  mounted () {
    // The sole need of this component is to add layers to layer control regardless of the visible flag
    this.$nextTick(() => {
      let lgroup = this.$refs.lgroup

      lgroup.parentContainer.addLayer(lgroup)
    })
  }
}
</script>
